import { FC, ReactNode, useEffect, useState } from 'react'
import cn from 'classnames'

import { ICrumb } from 'components/ui/account/breadcrumbs/breadcrumbs.interface'

import LocaleButton from 'components/ui/header/components/locale-button'

import { useRouter } from 'next/router'

import BreadCrumbs from '../../breadcrumbs'

import BackIcon from 'images/arrow-back.svg'

import styles from './styles.module.scss'

interface Props {
  title?: string | ReactNode
  crumbs?: boolean | ICrumb[]
  steps?: ReactNode
  className?: string
  backButton?: boolean
  onBack?: () => void
}

const ContentHeader: FC<Props> = ({ title, crumbs, className, children, backButton = false, onBack }) => {
  const [isOpen, setIsOpen] = useState(false)
  const [isAccount, setIsAccount] = useState(false)
  const router = useRouter()

  useEffect(() => {
    setIsAccount(router.pathname.includes('account'))
  }, [])

  return (
    <div className={cn(styles.contentHeader, className)}>
      {backButton && onBack && <button className={styles.back} onClick={onBack}>
        <img src={BackIcon} alt="back icon" />
      </button>}

      {title && <h1 className={cn(styles.contentTitle, { [styles['margin-left']]: backButton })}>{title}</h1>}
      <LocaleButton
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        className={cn(styles.localeBtn, (!isAccount || !router.pathname.includes('settings')) && styles.hidden)}
      />
      {children}
      {crumbs && (Array.isArray(crumbs) ? <BreadCrumbs pages={crumbs} isInverted /> : <BreadCrumbs />)}
    </div>
  )
}

export default ContentHeader
